import { Box } from '@mui/material';
import Autosuggest from 'components/controls/Autosuggest';
import { arrayOf, func, object, string } from 'prop-types';
import React from 'react';
import TagList from './TagList';

class TagsField extends React.Component {
  state = {
    suggestion: {},
  };

  add = suggestion => {
    const { name, value, onChange } = this.props;
    if (!suggestion) return;

    value.push(suggestion.value);
    this.setState({ suggestion: '' });

    onChange(name, value);
  };

  delete = tag => () => {
    const { name, value, onChange } = this.props;
    const tags = value.filter(t => t !== tag);
    onChange(name, tags);
  };

  createTag = newTag => {
    const { name, value, onChange, createTag } = this.props;
    createTag(newTag);
    onChange(name, [...value, newTag]);
  };

  render() {
    const { tags, value, ...props } = this.props;
    const { suggestion } = this.state;
    const suggestions = tags
      .filter(t => !value.includes(t))
      .map(tag => ({ value: tag, label: tag }));

    return (
      <Box>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ flexGrow: 1, p: '5px' }}>
            <Autosuggest
              {...props}
              creatable
              onCreate={this.createTag}
              suggestions={suggestions}
              value={suggestion}
              onChange={this.add}
            />
          </Box>
        </Box>
        <TagList tags={value} onDelete={this.delete} />
      </Box>
    );
  }
}

TagsField.propTypes = {
  onChange: func,
  value: arrayOf(string),
  name: string.isRequired,
  tags: arrayOf(string),
  actions: object.isRequired,
  createTag: func,
};
TagsField.defaultProps = {
  onChange: () => {},
  value: [],
  createTag: () => {},
  tags: [],
};

export default TagsField;
